import PropTypes from 'prop-types'
import React from 'react'
import { ServerResponseConsumer } from '../ServerResponseContext'

export default function StatusCode({ statusCode, children }) {
  if (process.browser) {
    return null
  }

  return (
    <ServerResponseConsumer>
      {response => {
        if (!response.finished) {
          response.statusCode = statusCode
        }
        return children
      }}
    </ServerResponseConsumer>
  )
}

StatusCode.propTypes = {
  statusCode: PropTypes.number.isRequired,
  children: PropTypes.any,
}

StatusCode.defaultProps = {
  children: null,
}
